import endpointConfig from "../configs/endpoint.config";
import httpConfig from "../configs/http.config";
import { UpdateFcmPayloadProps, UpdateFcmResponseProps } from "../types/user.type";

const userService = {
  updateFcm: async function(body: UpdateFcmPayloadProps) {
    const response = await httpConfig().post<UpdateFcmResponseProps>(endpointConfig.user.updateFcm, body)
    if (response.data.code !== '200') throw response.data
    return response.data
  }
}

export default userService